export default {
  text: 'You\'ve placed an order less than 15 minutes ago! Please confirm if you\'d like to proceed with this new order, or manage your existing one.',
  buttons: {
    see_existing_order: 'See Existing Order',
    proceed_new_order: 'Proceed New Order',
  },
};